var exports = {
  "Qs": "CameraPreviewModal.module__content___RGxGeE",
  "Wc": "CameraPreviewModal.module__backgroundSection___RGxGeE",
  "Pz": "CameraPreviewModal.module__backgroundLabel___RGxGeE",
  "Ip": "CameraPreviewModal.module__effectStrengthSlider___RGxGeE",
  "TM": "CameraPreviewModal.module__effectStrengthLabelRow___RGxGeE",
  "dI": "CameraPreviewModal.module__effectStrengthLabel___RGxGeE",
  "j": "CameraPreviewModal.module__videoContainer___RGxGeE",
  "qr": "CameraPreviewModal.module__footer___RGxGeE",
  "wu": "CameraPreviewModal.module__footerStart___RGxGeE",
  "Dr": "CameraPreviewModal.module__footerMirrorSwitch___RGxGeE",
  "Ki": "CameraPreviewModal.module__video___RGxGeE",
  "Lw": "CameraPreviewModal.module__overlay___RGxGeE",
  "um": "CameraPreviewModal.module__overlayText___RGxGeE",
  "nU": "CameraPreviewModal.module__overlayTextMedium___RGxGeE",
  "$q": "CameraPreviewModal.module__errorOverlay___RGxGeE",
  "kc": "CameraPreviewModal.module__errorText___RGxGeE",
  "JU": "CameraPreviewModal.module__errorTitle___RGxGeE",
  "m2": "CameraPreviewModal.module__errorDetail___RGxGeE",
};

module.exports = exports;
